module.exports = __webpack_public_path__ + "img/icon-recensements.04cc92b9.svg";